import script from "./MurphGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./MurphGraph.vue?vue&type=script&setup=true&lang=js"

import "./MurphGraph.vue?vue&type=style&index=0&id=e8e28d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8e28d4c"]])

export default __exports__